package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class VodItem(
    val id: String,
    val sourceId: String,
    val name: String,
    val streamUrl: String,
    val coverUrl: String? = null,
    val plot: String? = null,
    val genre: String? = null,
    val duration: Long? = null,
    val rating: Double? = null,
    val group: String? = null
)
